import type { TransactionData } from "~/types/trust-account";
import type { LedgerTransaction } from '@prisma/client'

export const useLedgerTransaction = () => {
    const createTransaction = async (
        transactionData: TransactionData
    ) => {
        try {
            const transaction = await $fetch(`/api/v1/ledger-transaction`, {
                method: 'POST',
                body: transactionData,
            });
            return { data: transaction, error: null };
        } catch (error) {
            console.error('Error creating transaction:', error);
            return { data: null, error };
        }
    };

    const updateTransaction = async (
        updatedTransaction: LedgerTransaction
    ) => {
        try {
            const transaction = await $fetch(`/api/v1/ledger-transaction/${updatedTransaction.id}`, {
                method: 'PUT',
                body: updatedTransaction,
            });
            return { data: transaction, error: null };
        } catch (error) {
            console.error('Error updating transaction:', error);
            return { data: null, error };
        }
    };

    const getTransactionById = async (transactionId: string) => {        
        try {
            const transaction = await $fetch(`/api/v1/ledger-transaction/${transactionId}`, {
                method: 'GET',
            });

            return { data: transaction, error: null };
        } catch (error) {
            console.error('Error fetching transaction:', error);
            return { data: null, error };
        }
    };

    const viewReceipt = async (receiptId: string) => {
        await navigateTo(`/trust-accounting/ledger/transaction/${receiptId}`, {
            open:{
                target: '_blank',
            }
        })
    }

    return {
        createTransaction,
        updateTransaction,
        getTransactionById,
        viewReceipt
    };
};
